export const UI_TIMEOUTS = {
  ALERT_DISMISS_MS: 5000,
  TOAST_DISMISS_MS: 3000,
  SUCCESS_BANNER_MS: 2500,
  SIMULATED_DELAY_MS: 120,
};
